import {
  ChevronDown,
  TextAppearance,
  TextColor,
  TextCustom,
  TextCustomProps,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import React from 'react';
import {StyledIcon, StyledLabelContainer} from './styles';

interface FilterContentLabelProps {
  label: string;
  hideOptions: boolean;
  setHideOptions: (value: boolean) => void;
  isMobile: boolean;
}
const FilterContentLabel: React.FC<FilterContentLabelProps> = ({
  label,
  hideOptions,
  setHideOptions,
  isMobile,
}) => {
  const styledLabelText: TextCustomProps = {
    appearance: TextAppearance.headline200,
    tag: TextTag.span,
    style: {
      fontSize: TextSize.TextSize16,
      lineHeight: TextLineHeight.TextLineHeight24,
      fontWeight: TextWeight.bold,
      color: TextColor.primary,
    },
  };
  return (
    <StyledLabelContainer
      onClick={() => isMobile && setHideOptions(!hideOptions)}
    >
      <TextCustom {...styledLabelText}> {label}</TextCustom>
      {isMobile && (
        <StyledIcon
          className={`filter-model-year-icon ${hideOptions && 'active'}`}
          hideOptions={hideOptions}
        >
          <div className={`animation ${hideOptions && 'active'}`}>
            <ChevronDown />
          </div>
        </StyledIcon>
      )}
    </StyledLabelContainer>
  );
};

export default FilterContentLabel;
